import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import Loader from '../../../commons/loader';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services';
import { PaginationTotal } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import NumberFormatter from '../../../commons/NumberFormatter';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import ProgressButton from '../../../commons/ProgressButton';

class JegyContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,
      cikk: null,
      cikkek: [],
      currentJegy: {},
      currentRow: [],
      existsHelyszinMS: null,
      existsTermekMS: null,
      helyszin: {},
      helyszinek: [],
      helyszinSelected: [],
      jegyJson: null,
      jegyModositObj: {},
      jegyKategoriaJson: null,
      jegyKategoriaModositJson: {},
      loading: false,
      modalJegy: false,
      modalJegyModosit: false,
      modalJegyNezet: false,
      modalJegyTorles: false,
      modalJegyKategoria: false,
      modalJegyKategoriaModosit: false,
      modalJegyKategoriaTorles: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDE']
      tableJegyStatus: 'HIDE',
      tableJegyKategoriaStatus: 'HIDE',

      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,

      addCatButtonLoading: false,
      modifyCatButtonLoading: false,
      deleteCatButtonLoading: false,
    };

    this.optionsJegy = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ]
    };
    this.optionsJegykategoria = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
    this.onRowSelect = this.onRowSelect.bind(this);
  }

  componentDidMount() {
    this.updateTable();
    this.checkMS('helyszin');
    this.checkMS('jegytermek');
    this.checkAngolNyelv();
    this.getPenznemOptions();
  }

  getPenznemOptions = () => {
    Service.listAktivPenznem((err, res) => {
      if(!err){
        this.setState({ penznemOptions: res[0].map( p => <option key={p.id} value={p.id}>{p.azonosito}</option>) });
      }
    })
  }

  checkMS = (msNev) => {
    Service.existsMS(msNev, (err, res) => {
      if (!err) {
        if (msNev === 'helyszin') {
          this.setState({ existsHelyszinMS: res[0] === true ? true : null });
        } else if (msNev === 'jegytermek') {
          this.setState({ existsTermekMS: res[0] === true ? true : null });
        }
      }
    });
  }

  checkAngolNyelv = () => {
    Service.getJegyAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  angolEngedelyezve = () => {
    return this.state.angolNyelv == true;
  }

  listArkategoriak = () => {
    Service.listArkategoriak((err, res) => {
      if (!err) {
        this.setState({ arkategoriak: res[0] });
      }
    });
  }

  handleJegyKategoriaEditClick = (id) => {
    this.setState((prevState) => {
      let jegyKategoriaModositJson = Object.assign({}, prevState.jegyKategoriaJson.find(element => element.id === id));
      jegyKategoriaModositJson.arkategoriakod = { nam: jegyKategoriaModositJson.kod, cod: jegyKategoriaModositJson.kod }
      return ({ jegyKategoriaModositJson: jegyKategoriaModositJson });
    }, () => {
      if (this.state.existsTermekMS) {
        this.listArkategoriak();
      }
      this.toggleJegyKategoriaModosit();
    });
  }

  handleJegyKategoriaDeleteClick = (id) => {
    this._currentKategoriaDeleteId = id;
    this.toggleJegyKategoriaTorles();
  }

  handleJegyEditClick = (id) => {
    this.setState((prevState) => {
      let jegyModositObj = Object.assign({}, prevState.jegyJson.find(element => element.id === id));
      return ({ jegyModositObj: jegyModositObj, helyszinSelected: jegyModositObj.helyszinek })
    }, () => {
      this.setState({ cikk: { id: this.state.jegyModositObj.cikkid, megnevezes: this.state.jegyModositObj.cikknev } });
      this.toggleJegyModosit();
    }
    );
  }

  handleJegyDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleJegyTorles();
  }

  handleViewClick = (id) => {
    let jegy = this.state.jegyJson.find(jegy => jegy.id === id);
    this._currentViewId = id;
    this.setState({ jegy: jegy }, () => {
      this.toggleNezet();
    });
  }

  handleCikkChange = (cikk) => {
    if (cikk) {
      this.setState({
        cikk: cikk
      });
    } else {
      this.setState({ cikk: null });
    }
  }

  handleHelyszinChange = (helyszinSelected) => {
    if (helyszinSelected) {
      this.setState({ helyszinSelected: helyszinSelected });
    } else {
      this.setState({ helyszinSelected: [] });
    }
  }

  handleArkategoriaChange = (arkategoriaSelected) => {
    if (arkategoriaSelected) {
      this.setState({ arkategoriaSelected: arkategoriaSelected });
    } else {
      this.setState({ arkategoriaSelected: [] });
    }
  }

  handleInputChangeCikk = (value, { action }) => {
    switch (action) {
      case 'input-change':
        if (value && value.length > 2) {
          this.setState({ loading: true }, () => {
            Service.getAktivCikkek(value, (err, res) => {
              if (!err) {
                this.setState({ cikkek: res[0] });
              }
              this.setState({ loading: false });
            });
          });
        }
        break;
      default:
    }
  }

  iconFormatter = (cell) => {
    return (
      <div className='row'>
        {
          <div className="col-md-12">
            {this.props.globals.hasRole(['JEGY_JEGY']) && (
              <React.Fragment>
                <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
              </React.Fragment>
            )}
            {this.props.globals.hasRole(['JEGY_JEGY'], true) && (
              <React.Fragment>
                <React.Fragment>
                  <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleJegyEditClick(cell)} />
                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
                </React.Fragment>
                <React.Fragment>
                  <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleJegyDeleteClick(cell)} />
                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
                </React.Fragment>
              </React.Fragment>
            )}
          </div>
        }
      </div>
    );
  }

  iconFormatterKategoria = (cell) => {
    return (
      <div>
        {this.props.globals.hasRole(['JEGY_JEGY'], true) && (
          <React.Fragment>
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleJegyKategoriaEditClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
            </React.Fragment>
            <React.Fragment>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleJegyKategoriaDeleteClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
            </React.Fragment>
          </React.Fragment>
        )}
      </div>
    );
  }

  cikkValaszto = () => {
    return (
      <SelectField
        label="Cikk:"
        name="cikkvalaszto"
        id="cikkvalaszto"
        placeholder="Válassz cikket..."
        noOptionsMessage={() => 'Nincs keresési eredmény'}
        loadingMessage={() => 'Keresés...'}
        isClearable
        ignoreAccents={false}
        isLoading={this.state.loading}
        onInputChange={_.debounce(this.handleInputChangeCikk, 1000)}
        onChange={this.handleCikkChange}
        options={this.state.cikkek}
        value={this.state.cikk}
        getOptionLabel={option => option.megnevezes}
        getOptionValue={option => option}
        required
      />
    );
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  getJegyList = () => {
    this.setState({
      tableJegyStatus: 'LOAD'
    }, () => {
      Service.listJegy((err, res) => {
        if (!err) {
          this.setState({ jegyJson: res[0], tableJegyStatus: res[0].length > 0 ? 'TABL' : 'DATA' });
        } else {
          this.setState({
            tableJegyStatus: 'NETW'
          });
        }
      });
    });
  }

  updateTable = () => {
    this.getJegyList();
  }

  updateJegyKategoriaTable = (id) => {
    this.setState({ tableJegyKategoriaStatus: 'LOAD' });
    Service.listJegyKategoria(id || this.state.currentJegy.id, (err, res) => {
      if (!err) {
        this.setState({ jegyKategoriaJson: res[0], tableJegyKategoriaStatus: res[0].length > 0 ? 'TABL' : 'DATA' });
      } else {
        this.setState({ tableJegyKategoriaStatus: 'NETW' });
      }
    });
  }

  getHelyszinek = () => {
    Service.listHelyszinSelect((err, res) => {
      if (!err) {
        this.setState({ helyszinek: res[0] });
      }
    });
  }

  toggleNezet = () => {
    this.setState((prevState) => { return ({ modalNezet: !prevState.modalNezet }); });
  }

  toggleJegy = () => {
    if (this.state.modalJegy === false && this.state.existsHelyszinMS) {
      this.getHelyszinek();
      this.setState({ helyszinek: [], helyszin: {}, helyszinSelected: [] });
    }
    this.setState((prevState) => { return ({ modalJegy: !prevState.modalJegy, cikk: null, cikkek: [] }); });
  }

  toggleJegyModosit = () => {
    if (this.state.existsHelyszinMS) {
      if (this.state.modalJegyModosit === false) {
        this.getHelyszinek();
        if (this.state.jegyModositObj.helyszinek) {
          this.setState({ helyszinSelected: this.state.jegyModositObj.helyszinek });
        }
      } else {
        this.setState({ helyszinek: [], jegyModositObj: {} });
      }
    }
    this.setState((prevState) => { return ({ modalJegyModosit: !prevState.modalJegyModosit, cikk: prevState.modalJegyModosit === true ? null : prevState.cikk, cikkek: [] }); });
  }

  toggleJegyTorles = () => {
    this.setState((prevState) => { return ({ modalJegyTorles: !prevState.modalJegyTorles }); });
  }

  toggleJegyKategoria = () => {
    if (this.state.existsTermekMS && this.state.modalJegyKategoria === false) {
      this.listArkategoriak();
    }
    this.setState((prevState) => { return ({ modalJegyKategoria: !prevState.modalJegyKategoria, arkategoriaSelected: null, jegyKategoriaModositJson: {} }); });
  }

  toggleJegyKategoriaModosit = () => {
    this.setState((prevState) => { return ({ modalJegyKategoriaModosit: !prevState.modalJegyKategoriaModosit, arkategoriaSelected: null }); });
  }

  toggleJegyKategoriaTorles = () => {
    this.setState((prevState) => { return ({ modalJegyKategoriaTorles: !prevState.modalJegyKategoriaTorles }); });
  }

  checkCikk = () => {
    if (!this.state.cikk) {
      this.props.globals.addError('Cikk választása kötelező!');
      return false;
    }
    return true;
  }

  checkAr = (ar) => {
    if (ar == "-0" || isNaN(ar)) {
      this.props.globals.addError('Az ár csak természetes szám lehet!');
      return false;
    }
    return true;
  }

  checkArkategoria = (jegyKategoriaObj) => {
    if (!this.state.arkategoriaSelected && (jegyKategoriaObj.arkategoriakod == null || jegyKategoriaObj.arkategoriakod == '')) {
      this.props.globals.addError('Árkategória választása kötelező!');
      return false;
    }
    return true;
  }

  addJegy = (event, jegyObj) => {
    jegyObj.ar = NumberFormatter.removeSpacesFromString(jegyObj.ar);
    jegyObj.fixAr = NumberFormatter.removeSpacesFromString(jegyObj.fixAr);
    if (this.checkCikk() && this.checkAr(jegyObj.ar)) {
      jegyObj.cikkid = this.state.cikk.id;
      if (this.state.existsHelyszinMS) {
        jegyObj.helyszinids = this.state.helyszinSelected.map((element) => {
          return element.id;
        });
      }
      jegyObj.publikus = jegyObj.publikus || false;
      this.setState({ addButtonLoading: true });
      Service.addJegy(jegyObj, (err) => {
        if (!err) {
          this.toggleJegy();
          this.updateTable();
          this.props.globals.addSuccess('Jegy hozzáadva!');
        }
        this.setState({ addButtonLoading: false });
      });
    }
  }

  editJegy = (event, jegyModositObj) => {
    jegyModositObj.ar = NumberFormatter.removeSpacesFromString(jegyModositObj.ar);
    jegyModositObj.fixAr = NumberFormatter.removeSpacesFromString(jegyModositObj.fixAr);
    if (this.checkCikk() && this.checkAr(jegyModositObj.ar)) {
      let jegyModositObj2 = Object.assign({}, this.state.jegyModositObj);
      if (this.state.existsHelyszinMS) {
        jegyModositObj2.helyszinids = this.state.helyszinSelected?.map((element) => {
          return element.id;
        });
      }
      jegyModositObj2.azonosito = jegyModositObj.azonosito;
      jegyModositObj2.nev = jegyModositObj.nev;
      jegyModositObj2.ar = jegyModositObj.ar;
      jegyModositObj2.fixAr = jegyModositObj.fixAr;
      jegyModositObj2.publikus = jegyModositObj.publikus || false;
      jegyModositObj2.leiras = jegyModositObj.leiras;
      jegyModositObj2.cikkid = this.state.cikk.id;
      jegyModositObj2.nevangol = jegyModositObj.nevangol;
      jegyModositObj2.leirasangol = jegyModositObj.leirasangol;
      jegyModositObj2.penznemid = jegyModositObj.penznemid;
      this.setState({ modifyButtonLoading: true });
      Service.modifyJegy(jegyModositObj2, (err) => {
        if (!err) {
          this.toggleJegyModosit();
          this.updateTable();
          this.props.globals.addSuccess('Jegy módosítva!');
        }
        this.setState({ modifyButtonLoading: false });
      });
    }
  }

  deleteJegy = () => {
    this.toggleJegyTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteJegy(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentRow: [], tableJegyKategoriaStatus: 'HIDE' });
        this.props.globals.addSuccess('Jegy törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  addJegyKategoria = (event, jegyKategoriaObj) => {
    jegyKategoriaObj.ar = NumberFormatter.removeSpacesFromString(jegyKategoriaObj.ar);
    if (this.checkArkategoria(jegyKategoriaObj) && this.checkAr(jegyKategoriaObj.ar)) {
      jegyKategoriaObj.jegyid = this.state.currentJegy.id;
      jegyKategoriaObj.arkategoriakod = this.state.arkategoriaSelected ? this.state.arkategoriaSelected.cod : jegyKategoriaObj.arkategoriakod;
      this.setState({ addCatButtonLoading: true });
      Service.addJegyKategoria(jegyKategoriaObj, (err) => {
        if (!err) {
          this.toggleJegyKategoria();
          this.updateJegyKategoriaTable();
          this.props.globals.addSuccess('Jegykategória hozzáadva!');
        }
        this.setState({ addCatButtonLoading: false });
      });
    }
  }

  editJegyKategoria = (event, jegyKategoriaObj) => {
    jegyKategoriaObj.ar = NumberFormatter.removeSpacesFromString(jegyKategoriaObj.ar);
    if (this.checkArkategoria(this.state.jegyKategoriaModositJson) && this.checkAr(jegyKategoriaObj.ar)) {
      let jegyKategoriaModositJson2 = Object.assign({}, this.state.jegyKategoriaModositJson);
      jegyKategoriaModositJson2.arkategoriakod = this.state.arkategoriaSelected ? this.state.arkategoriaSelected.cod : this.state.jegyKategoriaModositJson.arkategoriakod.cod;
      jegyKategoriaModositJson2.ar = jegyKategoriaObj.ar;
      jegyKategoriaModositJson2.jegyid = this.state.currentJegy.id;
      this.setState({ modifyCatButtonLoading: true });
      Service.modifyJegyKategoria(jegyKategoriaModositJson2, (err) => {
        if (!err) {
          this.toggleJegyKategoriaModosit();
          this.updateJegyKategoriaTable();
          this.props.globals.addSuccess('Jegykategória módosítva!');
        }
        this.setState({ modifyCatButtonLoading: false });
      });
    }
  }

  deleteJegyKategoria = () => {
    this.setState({ deleteCatButtonLoading: true });
    Service.deleteJegyKategoria(this._currentKategoriaDeleteId, (err) => {
      if (!err) {
        this.toggleJegyKategoriaTorles();
        this.updateJegyKategoriaTable();
        this.props.globals.addSuccess('Jegykategória törölve!');
      }
      this.setState({ deleteCatButtonLoading: false });
    });
  }

  renderHelyszinvalaszto = () => {
    return (
      <SelectField
        label='Helyszín(ek):'
        name="helyszinvalaszto"
        id="helyszinvalaszto"
        placeholder="Válassz helyszínt..."
        noOptionsMessage={() => 'Nincs választható helyszín'}
        isClearable
        ignoreAccents={false}
        onChange={this.handleHelyszinChange}
        options={this.state.helyszinek}
        value={this.state.helyszinSelected}
        getOptionLabel={option => option.nev}
        getOptionValue={option => option}
        isSearchable
        isMulti
        isOptionSelected={this.isHelyszinSelected}
      />
    );
  }

  renderArkategoriavalaszto = () => {
    return (
      <SelectField
        label='Árkategória:'
        name="arkategoriavalaszto"
        id="arkategoriavalaszto"
        placeholder="Válassz árkategóriát..."
        noOptionsMessage={() => 'Nincs választható árkategória'}
        isClearable
        ignoreAccents={false}
        onChange={this.handleArkategoriaChange}
        options={this.state.arkategoriak}
        defaultValue={this.state.jegyKategoriaModositJson ? this.state.jegyKategoriaModositJson.arkategoriakod : null}
        getOptionLabel={option => option.nam}
        getOptionValue={option => option}
        isSearchable
      />
    );
  }

  renderHelyszinek = () => {
    let helyszinek = [];
    for (let helyszin in this.state.jegy.helyszinek) {
      let helyszinObj = this.state.jegy.helyszinek[helyszin];
      helyszinek.push(<div key={helyszinObj.id}>{helyszinObj.nev}</div>)
    }
    return helyszinek;
  }

  renderAdatok = () => {
    return (
      <div>
        <b>Azonosító: </b>{this.state.jegy.azonosito}<br />
        <b>Név: </b>{this.state.jegy.nev}<br />
        {this.angolEngedelyezve() && 
          <div><b>Név (angol): </b>{this.state.jegy.nevangol}<br /></div>
        }
        <b>Cikk: </b>{this.state.jegy.cikknev}<br />
        <b>Ár: </b>{NumberFormatter.formatterSpaceOsszegPenznem(this.state.jegy.ar, null, this.state.jegy.penznemazonosito)}<br />
        <b>Fix ár: </b>{NumberFormatter.formatterSpaceOsszegPenznem((this.state.jegy.fixAr ? this.state.jegy.fixAr : 0), null, this.state.jegy.penznemazonosito)}<br />
        <b>Publikus: </b>{this.state.jegy.publikus === true ? "Igen" : "Nem"}<br />
        <br />
        <h6><b>Helyszínek:</b></h6>
        <div>{this.renderHelyszinek()}</div>
        {/* {this.state.existsHelyszinMS && <div><b>Helyszín neve: </b>{this.state.helyszin.nev}<br /></div>} */}
        {/* <b>Leírás: </b>{ReactHtmlParser(this.state.jegy.leiras)}<br /> */}
      </div>
    );
  }

  isHelyszinSelected = (helyszin, helyszinek) => {
    for (let helyszin2 of helyszinek) {
      if (helyszin.nev === helyszin2.nev) {
        return true;
      }
    }
    return false;
  }

  statusFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-default">Nem</span>;
  }

  onRowSelect(row) {
    this.setState({ currentJegy: row, currentRow: [row.id] });
    this.updateJegyKategoriaTable(row.id);
  }

  arFormatter = (cell, row) => {
    return NumberFormatter.formatterSpaceOsszegPenznem(cell, null, row.penznemazonosito);
  }

  arKategoriaFormatter = (cell, row) => {
    return NumberFormatter.formatterSpaceOsszegPenznem(cell, null, row.penznem);
  }

  renderTable = () => {
    let selectRowProp = {
      mode: 'radio',
      onSelect: this.onRowSelect,
      selected: this.state.currentRow
    };

    const selectOptions = {
      true: 'Igen',
      false: 'Nem',
    };

    const columnsHelyszinnel = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'cikknev',
        text: 'Cikk',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'helyszinlista',
        text: 'Helyszínek',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés',
        }),
        sort: true
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        formatter: this.arFormatter,
        sort: true
      },
      {
        dataField: 'publikus',
        text: 'Publikus',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes...',
        }),
        align: 'center',
        sort: true,
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    let columns = [
      ...columnsHelyszinnel
    ];
    columns.splice(2, 1);

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.jegyJson}
        columns={this.state.existsHelyszinMS ? columnsHelyszinnel : columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
        selectRow={selectRowProp}
      />
    );
  }

  renderKategoriaTable = () => {
    const columns = [
      {
        dataField: 'kod',
        text: 'Árkategória kód',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        formatter: this.arKategoriaFormatter,
        sort: true
      },
      {
        dataField: 'id',
        hidden: !this.props.globals.hasRole(['JEGY_JEGY'], true),
        text: 'Műveletek',
        formatter: this.iconFormatterKategoria
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.jegyKategoriaJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="row">
        {((this.state.tableJegyStatus === 'DATA' || this.state.tableJegyStatus === 'TABL')) && this.props.globals.hasRole(['JEGY_JEGY'], true) && (
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={() => this.toggleJegy()}>Új jegy hozzáadása</Button>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            {(this.state.tableJegyStatus === 'TABL' ? this.renderTable() : this.state.tableJegyStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableJegyStatus === 'DATA' ? <DataEmptyState hasImage /> : this.state.tableJegyStatus === 'LOAD' ? <Loader /> : <div />)}
            {(this.state.tableJegyKategoriaStatus !== 'HIDE') && this.props.globals.hasRole(['JEGY_JEGY'], true) && (
              <div className="row">
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.toggleJegyKategoria}>Új jegykategória</Button>
                </div>
              </div>
            )}
            {(this.state.tableJegyKategoriaStatus === 'TABL' ? this.renderKategoriaTable() : this.state.tableJegyKategoriaStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateJegyKategoriaTable} /> : this.state.tableJegyKategoriaStatus === 'DATA' ? <DataEmptyState hasImage /> : this.state.tableJegyKategoriaStatus === 'LOAD' ? <Loader /> : <div />)}
          </div>
        </div>
        <RFForm
          onSubmit={this.addJegy}
          modalInsert
          tagProps={{ isOpen: this.state.modalJegy, toggle: this.toggleJegy, backdrop: 'static' }}
          title='Jegy felvétel'
          footer={
            <React.Fragment>
              <ProgressButton loading={this.state.addButtonLoading} color="primary">Mentés</ProgressButton>{' '}
              <Button type="button" color="secondary" onClick={() => this.toggleJegy()}>Mégsem</Button>
            </React.Fragment>
          }
        >
          <RFField
             name="azonosito"
             label="Azonosító: *"
             required
          />
          <RFField
             name="nev"
             label="Név: *"
             required
          />
          {this.angolEngedelyezve() &&
            <RFField
              name="nevangol"
              label="Név (angol): *"
              required
           />
          }
          {this.cikkValaszto()}
         
          <div className="row mt-2">
            <div className="col-md-4">
            <SlaveAvInput
              id="ar"
              label="Ár: *"
              required
              szuroTipus={NumberFormatter.OSSZEG}
            />
            </div>
            <div className="col-md-4">
              <SlaveAvInput
                id="fixAr"
                label="Fix ár: "
                szuroTipus={NumberFormatter.OSSZEG}
              />
            </div>
            <div className="col-md-4" style={{ paddingTop: '35px' }}>
              <div>
                <div className="row">
                  <RFField
                    type="checkbox"
                    name="publikus"
                    id="publikus"
                    onChange={this.handleInputChange}
                    label={'Publikus'}
                  />
                  {/* <div style={{ paddingLeft: '10px' }}>Publikus</div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <RFField
                type="select"
                name="penznemid"
                label="Pénznem: *"
                errorMessage="Kötelező mező!"
                required
                defaultSelect={<option value="" disabled>Válassz pénznemet...</option>}
                selectOptions={this.state.penznemOptions}
                />
            </div>
          </div>
          {this.state.existsHelyszinMS &&
            <div className="row">
              <div className="col-md-12">
                {this.renderHelyszinvalaszto()}
              </div>
            </div>
          }

          <div style={{ paddingTop: 16 }}>
            <RFField
              type="textarea"
              name="leiras"
              label="Leírás: "
            />
          </div>
          {this.angolEngedelyezve() && 
            <RFField
              type="textarea"
              name="leirasangol"
              label="Leírás (angol): "
            />
          }
        </RFForm>
        <RFForm
            className={this.props.className}
            modalInsert
            title={'Jegy módosítás'}
            tagProps={{ isOpen: this.state.modalJegyModosit, toggle: this.toggleJegyModosit, backdrop: 'static' }}
            onSubmit={this.editJegy}
            footer={
              <React.Fragment>
                <ProgressButton loading={this.state.modifyButtonLoading} color="primary" type="submit">Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleJegyModosit}>Mégsem</Button>
              </React.Fragment>
            }>
                <RFField
                  type="text"
                  name="azonosito"
                  label="Azonosító: *"
                  errorMessage="Kötelező mező!"
                  value={this.state.jegyModositObj.azonosito}
                  disabled
                />
                <RFField
                  type="text"
                  name="nev"
                  label="Név: *"
                  errorMessage="Kötelező mező!"
                  value={this.state.jegyModositObj.nev}
                  required
                />
              {this.angolEngedelyezve() &&
                <RFField
                  type="text"
                  name="nevangol"
                  label="Név (angol): *"
                  errorMessage="Kötelező mező!"
                  value={this.state.jegyModositObj.nevangol}
                  required
                />
              }
              {this.cikkValaszto()}
              <div className="row mt-2">
                <div className="col-md-4">
                  <SlaveAvInput
                    id="ar"
                    label="Ár: *"
                    value={this.state.jegyModositObj.ar}
                    required
                    szuroTipus={NumberFormatter.OSSZEG}
                  />
                </div>
                <div className="col-md-4">
                  <SlaveAvInput
                    id="fixAr"
                    label="Fix ár: "
                    value={this.state.jegyModositObj.fixAr}
                    szuroTipus={NumberFormatter.OSSZEG}
                  />
                </div>
                <div className="col-md-4" style={{ paddingTop: '35px' }}>
                    <div className="row">
                      <RFField
                        type="checkbox"
                        name="publikus"
                        id="publikus"
                        value={this.state.jegyModositObj.publikus}
                        onChange={this.handleInputChange}
                        label={'Publikus'}
                      />
                      {/* <div style={{ paddingLeft: '10px' }}>Publikus</div> */}
                    </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <RFField 
                    type="select"
                    name="penznemid" 
                    label="Pénznem: *" 
                    errorMessage="Kötelező mező!"
                    defaultSelect={<option disabled value="">Válassz pénznemet...</option>}
                    selectOptions={this.state.penznemOptions}
                    required 
                    value={this.state.jegyModositObj.penznemid}
                    />
                </div>
              </div>
              {this.state.existsHelyszinMS &&
                <div className="row">
                  <div className="col-md-12">
                    {this.renderHelyszinvalaszto()}
                  </div>
                </div>
              }
              <div style={{ paddingTop: 16 }}>
                <RFField
                  type="textarea"
                  name="leiras"
                  label="Leírás: "
                  value={this.state.jegyModositObj.leiras}
                />
              </div>
              {this.angolEngedelyezve() &&
                <div style={{ paddingTop: 16 }}>
                  <RFField
                    type="textarea"
                    name="leirasangol"
                    label="Leírás (angol): "
                    value={this.state.jegyModositObj.leirasangol}
                  />
                </div>
              }
          </RFForm>
        <Modal isOpen={this.state.modalJegyTorles} toggle={this.toggleJegyTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a jegyet?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} color="primary" onClick={this.deleteJegy}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleJegyTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader >Jegy információ</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button></ModalFooter>
        </Modal>
          <RFForm
            onSubmit={this.addJegyKategoria}
            modalInsert
            title={'Jegykategória felvétel'}
            tagProps={{ isOpen: this.state.modalJegyKategoria, toggle: this.toggleJegyKategoria, className: this.props.className, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <ProgressButton loading={this.state.addCatButtonLoading} color="primary">Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleJegyKategoria}>Mégsem</Button>
              </React.Fragment>
            }
          >
              <>
                {this.state.existsTermekMS ?
                  this.renderArkategoriavalaszto()
                  :
                  <RFField
                    type="text"
                    name="arkategoriakod"
                    label="Árkategoria kód: *"
                    errorMessage="Kötelező mező!"
                    required
                  />
                }
              </>
              <SlaveAvInput
                id="ar"
                label="Ár: *"
                type="text"
                required
                szuroTipus={NumberFormatter.OSSZEG}
              />
          </RFForm>
          <RFForm
            onSubmit={this.editJegyKategoria}
            modalInsert
            title={'Jegykategória módosítás'}
            tagProps={{ isOpen: this.state.modalJegyKategoriaModosit, toggle: this.toggleJegyKategoriaModosit, className: this.props.className, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <ProgressButton loading={this.state.modifyCatButtonLoading} color="primary">Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleJegyKategoriaModosit}>Mégsem</Button>
              </React.Fragment>
            }
          >
              <div>
                <RFField
                  type="text"
                  name="arkategoriakod"
                  label="Árkategoria kód: *"
                  errorMessage="Kötelező mező!"
                  value={this.state.jegyKategoriaModositJson.arkategoriakod ? this.state.jegyKategoriaModositJson.arkategoriakod.cod : null}
                  required
                  disabled
                />
              </div>
              <SlaveAvInput
                id="ar"
                label="Ár: *"
                type="text"
                value={this.state.jegyKategoriaModositJson.ar}
                required
                szuroTipus={NumberFormatter.OSSZEG}
              />
          </RFForm>
        <Modal isOpen={this.state.modalJegyKategoriaTorles} toggle={this.toggleJegyKategoriaTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a jegykategóriát?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteCatButtonLoading} color="primary" onClick={this.deleteJegyKategoria}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleJegyKategoriaTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
};

export default JegyContent;
